<template>
	<div>
		<div class="voucher-card" :key="voucher.voucherId">
			<div class="voucher-header">
				{{ $t("utilityComponents.voucherCarousel.carouselItem.titleText") }}
			</div>
			<div class="voucher-content">
				{{voucher.options.productLabel | translate(`priceRule.${voucher.priceRuleId}.productLabel`)}}
			</div>
			<div class="dashed-line"></div>
			<v-btn
				@click="hasMultipleProducts ? showSelectionModal() : takeAward(product && product.id, voucher.voucherId)"
				:ripple="false"
				class="voucher-button"
				primary
				flat
			>
				{{ $t("utilityComponents.voucherCarousel.carouselItem.buttonText") }}
			</v-btn>
		</div>
		<VoucherProductSelection
			v-if="hasMultipleProducts && getProducts.length"
			:showModal="showModal"
			:products="getProducts"
			:applicableDiscount="getApplicableDiscount(voucher.voucherId)"
			@closeVoucherProductSelectionModal="showModal = false"
			@productSelected="takeAward($event, voucher.voucherId)"
		/>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import appConfig, {frequentlyUsedChannelEnum} from "../../../../appconfig";
import takeAwardMixin from "../../../../mixins/voucherReward/takeAward.mixin";
import VoucherProductSelection from "../../VoucherProductSelection.vue";
import * as mutationTypes from "../../../../store/mutation-types";
import {isProductCatalogDataAvailable} from "../../../../store/ProductCatalogNonReactiveStorage";

export default {
	name: "VoucherCarouselItem",
	components: {VoucherProductSelection},
	props: {
		voucher: {
			type: Object,
			required: true
		},
		isVoucherCarouselContext: {
			type: Boolean,
			default: false
		},
		userVouchers: {
			type: Array,
			default: () => []
		},
		voucherProducts: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showModal: false
		};
	},
	async created() {
		const priceRules = this.$store.getters.priceRules || [];
		if(!priceRules || !priceRules.length) {
			await this.$store.dispatch(mutationTypes.FETCH_PRICE_RULES);
		}
	},
	mixins: [takeAwardMixin],
	computed: {
		...mapGetters(["productCatalog", "cartProducts", "featureToggles", "globalSelectedShop"]),
		product() {
			const productId = this.voucher.productPattern[0];
			if(!productId) return null;
			if(!isProductCatalogDataAvailable()) {
				return this.voucherProducts.find(p => p.id === productId);
			}
			return this.productCatalog.getProduct(productId, true);
		},
		getProducts() {
			return this.voucher.productPattern.map(productId => {
				if(!isProductCatalogDataAvailable()) {
					return this.voucherProducts.find(p => p.id === productId);
				}
				return this.productCatalog.getProduct(productId, true);
			}).filter(Boolean);
		},
		hasMultipleProducts() {
			return this.voucher.productPattern && this.voucher.productPattern.length > 1;
		},
		isMobile() {
			return appConfig.channelAlias() === frequentlyUsedChannelEnum.mobileApp || appConfig.channelAlias() === frequentlyUsedChannelEnum.mobileBrowser;
		}
	},
	methods: {
		showSelectionModal() {
			this.showModal = true;
		},
		getApplicableDiscount(voucherId) {
			const priceRules = this.$store.getters.priceRules || [];
			return priceRules.find(pr => pr.voucherPattern && pr.voucherPattern.includes(voucherId));
		}
	}
};
</script>

<style scoped lang="scss">
.voucher-card {
	background-color: #393939;
	color: white;
	padding: 20px;
	border-radius: 10px;
	text-align: center;
	position: relative;
	overflow: hidden;
	&:not(:first-child) {
		margin-left: 10px;
	}
}

.voucher-card::before,
.voucher-card::after {
	content: '';
	position: absolute;
	width: 20px;
	height: 20px;
	background-color: #000000;
	border-radius: 50%;
	bottom: 58px;
	transform: translateY(-50%);
	z-index: 1;
}

.voucher-card::before {
	left: -10px;
}

.voucher-card::after {
	right: -10px;
}

.voucher-header {
	font-size: 12px;
	color: #FFFFFF;
	margin-bottom: 10px;
	text-align: start;
}

.voucher-content {
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	text-transform: uppercase;
	text-align: start;
}

.dashed-line {
	border-top: 1px dashed #ccc;
	margin: 20px 0;
}

.voucher-button {
	background-color: #ffd700;
	color: #000;
	font-size: 14px;
	font-weight: 700;
	border: none;
	padding: 10px 15px;
	border-radius: 3px;
	cursor: pointer;
	width: 100%;
	margin: 0;
	text-transform: unset;
}

</style>
